const firebaseConfig = {
  apiKey: "AIzaSyD67OAZnC3gllNovHiMyZ_GKqSxzfoKNGA",
  authDomain: "carhunt-14f9a.firebaseapp.com",
  projectId: "carhunt-14f9a",
  storageBucket: "carhunt-14f9a.appspot.com",
  messagingSenderId: "425141565063",
  appId: "1:425141565063:web:e62f1f0ffdb4b4f998ea22",
};

export default firebaseConfig;
